import { Suspense } from 'react';
import LoadingSpinner from '@/components/ui/LoadingSpinner';

function MainLayout({ children }: { children?: React.ReactNode }) {
    return (
        <Suspense fallback={<LoadingSpinner hasBackground={false} />}>
            {children}
        </Suspense>
    );
}

export default MainLayout;
